import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useMainMenu({ isAuthenticated, user }) {
  const { t } = useTranslation();

  const baseMenu = [
    {
      path: '/login',
      title: t('menu_inicio')
    },
    {
      path: '/contacto',
      title: ' 📞 ' + t('footer_contacto')
    },
    {
      title: t('menu_admin'),
      submenu: [
        { path: '/admin/chat_de_soporte', title: ' 💬 ' + t('menu_admin_chat_support') },
        { path: '/admin/stats', title: ' 📊 ' + t('menu_admin_stats') },
        { path: '/admin/inhabiles', title: ' 📅 ' + t('menu_admin_inhabiles') },
        { path: '/admin/reservas', title: ' 📋 ' + t('menu_admin_reservas') },
        { path: '/admin/qrs', title: ' 🎫 ' + t('menu_admin_qrs_promocionales') },
        { path: '/admin/mapa', title: ' 🗺️ ' + t('menu_admin_mapa') },
        { path: '/admin/clientes', title: ' 👥 ' + t('menu_admin_clientes') },
        { path: '/admin/conductores', title: ' 🚕 ' + t('menu_admin_conductores') },
        { path: '/admin/notificaciones/email', title: ' 📧 ' + t('menu_admin_notificaciones_email') },
        { path: '/admin/security', title: ' 🔐 ' + t('menu_admin_seguridad') },
        { path: '/admin/scheduler', title: ' ⏰ ' + t('menu_admin_tareas_programadas') },
        { path: '/admin/vuelos', title: ' ✈️ ' + t('menu_admin_vuelos', { defaultValue: 'Vuelos' }) },
        { path: '/admin/settings', title: ' ⚙️ ' + t('menu_admin_settings') },
      ]
    },
  ];

  const reservasMenu = {
    title: t('menu_reservas'),
    submenu: [
      { path: '/cliente/reserva', title: ' 🚖 ' + t('menu_reservas_anonima') },
    ]
  };

  const miOvertaxiMenu = useMemo(() => ({
    title: t('menu_miovertaxi'),
    submenu: [
      { path: '/cliente/reserva', title: ' 🚖 ' + t('menu_miovertaxi_nueva_reserva') },
      { path: '/cliente/mis-reservas', title: ' 📋 ' + t('menu_miovertaxi_mis_reservas') },
      { path: '/cliente/perfil', title: ' 👤 ' + t('menu_miovertaxi_perfil') },
      /*
      { path: '/cliente/reserva-activa', title: t('menu_miovertaxi_servicio') },
       */
    ]
  }), [t]);

  const conductorMenu = useMemo(() => ({
    title: t('menu_conductor'),
    submenu: [
      { path: '/conductor/servicio-activo', title: ' 🚕 ' + t('menu_conductor_servicio') },
      { path: '/conductor/bolsa-servicios', title: ' 📦 ' + t('menu_conductor_bolsa') },
      { path: '/conductor', title: ' 👤 ' + t('menu_conductor_perfil') },
    ]
  }), [t]);

  let menu = [...baseMenu];

  if (!isAuthenticated) {
    menu = menu.filter(item => item.title !== t('menu_admin'));
    menu.splice(1, 0, reservasMenu);
  } else if (user?.user_type === "cliente" && !user?.isAnonymous) {
    // Cliente autenticado explícitamente (no anónimo)
    menu = menu.filter(item => item.title !== t('menu_admin'));
    menu.splice(1, 0, miOvertaxiMenu);
  } else if (user?.user_type === "cliente" && user?.isAnonymous) {
    // Usuario anónimo - mostrar menú público
    menu = menu.filter(item => item.title !== t('menu_admin'));
    menu.splice(1, 0, reservasMenu);
  } else if (user?.user_type === "conductor") {
    menu = menu.filter(item => item.title !== t('menu_admin'));
    menu.splice(1, 0, conductorMenu);
    // Asegurar que no se muestra miOvertaxiMenu para conductores
  } else if (user?.user_type === "administrador") {
    // Filtrar menú de administrador según sub_rol
    const adminMenu = menu.find(item => item.title === t('menu_admin'));
    
    if (adminMenu && user?.sub_rol) {
      const subRol = user.sub_rol;
      
      // Definir qué items están permitidos para cada sub_rol
      const allowedItems = {
        'full_control': adminMenu.submenu, // Acceso a todos los items
        'auditor': adminMenu.submenu.filter(item => 
          item.path === '/admin/stats' || 
          item.path === '/admin/mapa' ||
          item.path === '/admin/vuelos'
        ),
        'read_only': adminMenu.submenu.filter(item => 
          item.path === '/admin/stats' || 
          item.path === '/admin/mapa' || 
          item.path === '/admin/notificaciones/email' ||
          item.path === '/admin/vuelos'
        )
      };
      
      // Aplicar filtro según sub_rol
      adminMenu.submenu = allowedItems[subRol] || adminMenu.submenu;
    }
    
    menu = menu.filter(item => item.title === t('menu_admin'));
  }

  return menu;
}